<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on, attrs }">
			<v-btn x-small icon v-bind="attrs" v-on="on" click.stop>
				<MoreHoriz :color="color" width="20" height="20"/>
			</v-btn>
		</template>
		<div v-for="item in menulists_filter"
			:key="item.key"
			@click.stop="onClickMenuItem(item.key, item.usable)" 
			@mouseover="item.isHover = true"
			@mouseout="item.isHover = false"
			class="d-print-none" >
			<div class="menu-item " :class="item.usable ? 'menu-able':'menu-delete-disable'">
				<component
					:style="item.key === 'find' ? 'width: 20px; height: 20px':'width: 18px; height: 18px'" 
					:is="item.icon"
					:color="item.color"
					:selected="item.isHover" 
					:selected_color="`#81CC00`"
					class="mr-3" 
				/>
				{{ item.title }}
			</div>
		</div>
		<div class="d-print-none menu-delete" :class="deleteColor" 
			@click.stop="onDelete()" 
			@mouseover="isHover = true"
			@mouseout="isHover = false">
			<Delete
				width="20"
				height="20"
				class="mr-2" 
				style="margin-left: 2px; margin-top: 2px"
				:color="deleteIconColor"
				:selected="isHover && !hasChild" 
				:selected_color="deleteSelectedColor"/>
			<div>Delete</div>
		</div>
	</v-menu>
</template>
<script>
import MoreHoriz from "@/components/icons/more-horiz";
import Rename from '@/components/icons/rename';
import Copy from '@/components/icons/copy';
import Share from '@/components/icons/share';
import Delete from '@/components/icons/delete_outline';
import Tick from '@/components/icons/tick';
import UnTick from '@/components/icons/unapprove.vue';
import Item from '@/components/icons/item';
import TimeSheet from "@/components/icons/timesheet";
import Email from "@/components/icons/email";
import SubTask from '@/components/icons/sub_task';
import FindTimesheet from "@/components/icons/find_timesheet";

const Event_Task = 'task';
const Event_Timesheet = 'timesheet';
const Event_Leave = 'leave';
const Event_Item = 'item';
const Event_Events = 'events';
const Event_Holiday = 'holiday';

const SHOW_COLOR = '#192A3E';
const SELECTED_COLOR = '#F45252';
const DISABLE_COLOR = '#82899B';

/* If selected, user will only be allow to amend items their own timesheets */
const TS = 'TS';

/* If selected, the user is allowed to delete timesheet entries */
const TsD = 'TsD';

/* the user will be able to enter and amend Items Charges */
const CH = 'CH';

/** If selected the user can only modify events he/she owns (has created) */
const EVOwn = 'EVOwn';

/** If selected the user can manage and approve leave events */
const DAppLeave = 'DAppLeave';

/** If selected the user can delete approved leave events if not already in a payslip */
const DDelAppLeave = 'DDelAppLeave';

/** If selected the user can manage public holidays */
const DPubHol = 'DPubHol';

/** If selected the user is allowed to approve payslips */
const PRapp = 'PRapp';


const MENU_LIST = [
	{
		key: 'addtimesheet',
		title: 'Add Timesheet',
		icon: TimeSheet,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: [Event_Events]
	},
	{
		key: 'invite',
		title: 'Forward invite...',
		icon: Email,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: [Event_Events]
	},
	{
		key: 'edit',
		title: 'Edit',
		icon: Rename,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: [Event_Task, Event_Timesheet, Event_Leave, Event_Item, Event_Events, Event_Holiday]
	},
	{
		key: 'duplicate',
		title: 'Duplicate',
		icon: Copy,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: [Event_Task, Event_Timesheet, Event_Item, Event_Events]
	},
	{
		key: 'subtask',
		title: 'Add Subtask',
		icon: SubTask,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: [Event_Task]
	},
	{
		key: 'additem',
		title: 'Add Item',
		icon: Item,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: [Event_Task, Event_Timesheet]
	},
	{
		key: 'find',
		title: 'Find timesheets',
		icon: FindTimesheet,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: [Event_Task]
	},
	{
		key: 'share',
		title: 'Share',
		icon: Share,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: [Event_Task]
	},
	{
		key: 'approved',
		title: 'Approve',
		icon: Tick,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: [Event_Leave, Event_Holiday]
	},
	{
		key: 'unapprove',
		title: 'Unapprove',
		icon: UnTick,
		color: SHOW_COLOR,
		usable: true,
		isHover: false,
		access: [Event_Leave, Event_Holiday]
	}
];

export default {
	name: 'TaskCalendarItemMenu',
	props: {
		hasChild: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: ''
		},
		color: {
			type: String,
			default: 'rgba(25, 42, 62, 0.7)'
		},
		privileges: {
			type: Array,
			default: () => []
		},
		isPrivilege: {
			/** Amend tasks, If selected the user will be able to create and amend tasks */
			type: Boolean,
			default: true
		},
		isCompleted: {
			type: Boolean,
			default: false
		},
		isApproved: {
			type: Boolean,
			default: false
		},
		isPaid: {
			type: Boolean,
			default: false
		},
		isPartPaid: {
			type: Boolean,
			default: false
		},
		isIncludingJob: {
			type: Boolean,
			default: false
		},
		isInviteMultiple: {
			type: Boolean,
			default: false
		},
		isCreatByOther: {
			type: Boolean,
			default: false
		},
		isOwnLeave: {
			type: Boolean,
			default: true
		}
	},
	data() {
		this.selected_color = SELECTED_COLOR;

		return {
			menu_list: MENU_LIST,
			isHover: false,
		}
	},
	components: {
		MoreHoriz,
		Rename,
		Copy,
		Share,
		Delete,
		Tick,
		Item,
		SubTask,
		FindTimesheet
	},
	computed: {
		menulists_filter () {
			const arr = [];
			this.menu_list.forEach(menu => {
				if (menu.access.includes(this.type)) {
					if (this.type === Event_Timesheet) {
						if (menu.key === 'additem') {
							const menu_tmp = {
								color: this.privileges.includes(CH) ? menu.color : DISABLE_COLOR,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: this.privileges.includes(CH) ? true: false
							};

							arr.push(menu_tmp);
						} else if (menu.key === 'duplicate') {
							const menu_tmp = {
								color: menu.color,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: true
							};

							arr.push(menu_tmp);
						} else {
							const menu_tmp = {
								color: this.privileges.includes(TS) ? menu.color : DISABLE_COLOR,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: this.privileges.includes(TS) ? true: false
							};

							arr.push(menu_tmp);
						}
					} else if(this.type === Event_Task) {
						if (menu.key === 'duplicate') {
							const menu_tmp = {
								color: this.isPrivilege ? menu.color : DISABLE_COLOR,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: this.isPrivilege ? true: false
							};

							arr.push(menu_tmp);
						} else if(menu.key === 'edit') {
							const menu_tmp = {
								color: this.isCompleted ? DISABLE_COLOR : menu.color,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: this.isCompleted ? false : true
							};

							arr.push(menu_tmp);
						} else if(menu.key === 'additem') {
							const menu_tmp = {
								color: this.privileges.includes(CH) ? menu.color : DISABLE_COLOR,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: this.privileges.includes(CH) ? true: false
							};

							arr.push(menu_tmp);
						} else if(menu.key === 'subtask') {
							const menu_tmp = {
								color: this.isPrivilege && !this.isCompleted ? menu.color : DISABLE_COLOR,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: this.isPrivilege && !this.isCompleted ? true : false
							};

							arr.push(menu_tmp);
						}
						else {
							const menu_tmp = {
								color: menu.color,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: menu.usable
							};

							arr.push(menu_tmp);
						}
						
					} else if(this.type === Event_Item) {
						const menu_tmp = {
							color: this.privileges.includes(CH) ? menu.color : DISABLE_COLOR,
							icon: menu.icon,
							isHover: menu.isHover,
							key: menu.key,
							title: menu.title,
							usable: this.privileges.includes(CH) ? true: false
						};

						arr.push(menu_tmp);
					} else if(this.type === Event_Leave) {
						if (menu.key === 'edit') {
							if (this.isPaid) {
								const menu_tmp = {
									color: DISABLE_COLOR,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: false
								};

								arr.push(menu_tmp);
							} else if (this.isPartPaid) {
								const menu_tmp = {
									color: this.privileges.includes(PRapp) && this.privileges.includes(DAppLeave) ? menu.color : DISABLE_COLOR ,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: this.privileges.includes(PRapp) && this.privileges.includes(DAppLeave) ? true: false
								};

								arr.push(menu_tmp);
							} else if (this.isApproved) {
								const menu_tmp = {
									color: this.privileges.includes(DAppLeave) ? menu.color : DISABLE_COLOR ,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: this.privileges.includes(DAppLeave) ? true: false
								};

								arr.push(menu_tmp);
							} else {
								let is_able = false;

								if (this.isOwnLeave) {
									is_able = true;
								} else {
									is_able = this.privileges.includes(DAppLeave) ? true: false;
								}

								const menu_tmp = {
									color: is_able ? menu.color : DISABLE_COLOR,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: is_able
								};

								arr.push(menu_tmp);
							}
							
						} else if (menu.key === 'approved') {
							if (!this.isPaid && !this.isApproved) {
								const menu_tmp = {
									color: this.privileges.includes(DAppLeave) ? menu.color : DISABLE_COLOR,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: this.privileges.includes(DAppLeave) ? true: false
								};

								arr.push(menu_tmp);
							}
							
						} else if(menu.key === 'unapprove') {
							if (!this.isPaid && this.isApproved) {
								const menu_tmp = {
									color: this.privileges.includes(DAppLeave) && !this.isPartPaid ? menu.color : DISABLE_COLOR,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: this.privileges.includes(DAppLeave) && !this.isPartPaid ? true: false
								};

								arr.push(menu_tmp);
							}
							
						} else {
							const menu_tmp = {
								color: menu.color,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: true
							};

							arr.push(menu_tmp);
						}
					} else if(this.type === Event_Events) {
						if (menu.key === 'addtimesheet') {
							if (this.isIncludingJob) {
								const menu_tmp = {
									color: menu.color,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: menu.usable
								};

								arr.push(menu_tmp);
							}
						} else if (menu.key === 'invite') {
							if (this.isInviteMultiple) {
								const menu_tmp = {
									color: this.isCreatByOther && this.privileges.includes(EVOwn) ? DISABLE_COLOR : menu.color,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: this.isCreatByOther && this.privileges.includes(EVOwn) ? false : true
								};

								arr.push(menu_tmp);
							}
						} else if (menu.key === 'edit') {
							const menu_tmp = {
								color: this.isCreatByOther && this.privileges.includes(EVOwn) ? DISABLE_COLOR : menu.color,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: this.isCreatByOther && this.privileges.includes(EVOwn) ? false : true
							};

							arr.push(menu_tmp);
						} else {
							const menu_tmp = {
								color: menu.color,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: menu.usable
							};

							arr.push(menu_tmp);
						}
					} else if(this.type === Event_Holiday) {
						if (menu.key === 'edit') {
							if (this.isPaid) {
								const menu_tmp = {
									color: DISABLE_COLOR,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: false
								};

								arr.push(menu_tmp);
							} else if (this.isApproved) {
								const menu_tmp = {
									color: this.privileges.includes(DPubHol) && this.privileges.includes(DAppLeave) ? menu.color : DISABLE_COLOR,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: this.privileges.includes(DPubHol) && this.privileges.includes(DAppLeave)  ? true: false
								};

								arr.push(menu_tmp);
							} else {
								const menu_tmp = {
									color: this.privileges.includes(DPubHol) ? menu.color : DISABLE_COLOR,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: this.privileges.includes(DPubHol) ? true: false
								};

								arr.push(menu_tmp);
							}
							
						} else if (menu.key === 'approved') {
							if (!this.isPaid && !this.isApproved) {
								const menu_tmp = {
									color: this.privileges.includes(DAppLeave) ? menu.color : DISABLE_COLOR,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: this.privileges.includes(DAppLeave) ? true: false
								};

								arr.push(menu_tmp);
							}
							
						} else if(menu.key === 'unapprove') {
							if (!this.isPaid && this.isApproved) {
								const menu_tmp = {
									color: this.privileges.includes(DAppLeave) ? menu.color : DISABLE_COLOR,
									icon: menu.icon,
									isHover: menu.isHover,
									key: menu.key,
									title: menu.title,
									usable: this.privileges.includes(DAppLeave) ? true: false
								};

								arr.push(menu_tmp);
							}
							
						} else {
							const menu_tmp = {
								color: menu.color,
								icon: menu.icon,
								isHover: menu.isHover,
								key: menu.key,
								title: menu.title,
								usable: menu.usable
							};

							arr.push(menu_tmp);
						}
					}
				}				
			});

			return arr;
		},
		deleteColor() {
			if (this.type === Event_Timesheet) {
				return this.privileges.includes(TsD) ? 'menu-delete-able':'menu-delete-disable';
			} else if(this.type === Event_Task) {
				return !this.hasChild && this.isPrivilege ? 'menu-delete-able':'menu-delete-disable';
			} else if(this.type === Event_Item) {
				return this.privileges.includes(CH) ? 'menu-delete-able':'menu-delete-disable';
			} else if(this.type === Event_Leave) {
				let is_able = false;

				if (!this.isPaid) {
					if (this.isApproved) {
						is_able = this.privileges.includes(DDelAppLeave) ? true : false;
					} else {
						if (this.isOwnLeave) {
							is_able = true;
						} else {
							is_able = this.privileges.includes(DAppLeave) ? true: false;
						}
					}
				}

				return is_able ? 'menu-delete-able':'menu-delete-disable';
			} else if(this.type === Event_Holiday) {
				const is_able = this.privileges.includes(DPubHol) ? true : false;
				return !this.isPaid && is_able ? 'menu-delete-able':'menu-delete-disable';
			} else if(this.type === Event_Events) {
				return this.isCreatByOther && this.privileges.includes(EVOwn) ? 'menu-delete-disable':'menu-delete-able';
			} else {
				return 'menu-delete-able';
			}
		},
		deleteIconColor() {
			if (this.type === Event_Timesheet) {
				return this.privileges.includes(TsD) ? SHOW_COLOR : DISABLE_COLOR;
			} else if(this.type === Event_Task) {
				return !this.hasChild && this.isPrivilege ? SHOW_COLOR : DISABLE_COLOR;
			} else if(this.type === Event_Item) {
				return this.privileges.includes(CH) ? SHOW_COLOR : DISABLE_COLOR;
			} else if(this.type === Event_Leave) {
				let is_able = false;

				if (!this.isPaid) {
					if (this.isApproved) {
						is_able = this.privileges.includes(DDelAppLeave) ? true : false;
					} else {
						if (this.isOwnLeave) {
							is_able = true;
						} else {
							is_able = this.privileges.includes(DAppLeave) ? true: false;
						}
					}
				}

				return is_able ? SHOW_COLOR : DISABLE_COLOR;
			} else if(this.type === Event_Holiday) {
				const is_able = this.privileges.includes(DPubHol) ? true : false;
				return !this.isPaid && is_able ? SHOW_COLOR : DISABLE_COLOR;
			} else if(this.type === Event_Events) {
				return this.isCreatByOther && this.privileges.includes(EVOwn) ? DISABLE_COLOR:SHOW_COLOR;
			} else {
				return SHOW_COLOR;
			}
		},
		deleteSelectedColor() {
			if (this.type === Event_Timesheet) {
				return this.privileges.includes(TsD) ? SELECTED_COLOR : DISABLE_COLOR;
			} else if(this.type === Event_Task) {
				return !this.hasChild && this.isPrivilege ? SELECTED_COLOR : DISABLE_COLOR;
			} else if(this.type === Event_Item) {
				return this.privileges.includes(CH) ? SELECTED_COLOR : DISABLE_COLOR;
			} else if(this.type === Event_Leave) {
				let is_able = false;

				if (!this.isPaid) {
					if (this.isApproved) {
						is_able = this.privileges.includes(DDelAppLeave) ? true : false;
					} else {
						if (this.isOwnLeave) {
							is_able = true;
						} else {
							is_able = this.privileges.includes(DAppLeave) ? true: false;
						}
					}
				}

				return is_able ? SELECTED_COLOR : DISABLE_COLOR;
			} else if(this.type === Event_Holiday) {
				const is_able = this.privileges.includes(DPubHol) ? true : false;
				return !this.isPaid && is_able ? SELECTED_COLOR : DISABLE_COLOR;
			}  else if(this.type === Event_Events) {
				return this.isCreatByOther && this.privileges.includes(EVOwn) ? DISABLE_COLOR:SELECTED_COLOR;
			} else {
				return SELECTED_COLOR;
			}
		}
	},
	methods: {
		onClickMenuItem(key, usable) {
			if (this.type === Event_Timesheet) {
				if (usable) {
					this.$emit('click-menu-item', key)
				}
			} else if(this.type === Event_Task) {
				if (usable) {
					this.$emit('click-menu-item', key)
				}
			} else if(this.type === Event_Item) {
				if (usable) {
					this.$emit('click-menu-item', key)
				}
			} else if(this.type === Event_Leave) {
				if (usable) {
					this.$emit('click-menu-item', key)
				}
			} else if(this.type === Event_Holiday) {
				if (usable) {
					this.$emit('click-menu-item', key)
				}
			} else if(this.type === Event_Events) {
				if (usable) {
					this.$emit('click-menu-item', key)
				}
			} else {
				this.$emit('click-menu-item', key)
			}
		},
		onDelete() {
			if (this.type === Event_Timesheet) {
				if (this.privileges.includes(TsD)) {
					this.$emit('delete');
				}
			} else if(this.type === Event_Task) {
				if (!this.hasChild && this.isPrivilege) {
					this.$emit('delete');
				}
			} else if(this.type === Event_Item) {
				if (this.privileges.includes(CH)) {
					this.$emit('delete');
				}
			} else if(this.type === Event_Leave) {
				let is_able = false;

				if (!this.isPaid) {
					if (this.isApproved) {
						is_able = this.privileges.includes(DDelAppLeave) ? true : false;
					} else {
						if (this.isOwnLeave) {
							is_able = true;
						} else {
							is_able = this.privileges.includes(DAppLeave) ? true: false;
						}
					}
				}

				if (is_able) {
					this.$emit('delete');
				}
			} else if(this.type === Event_Holiday) {
				const is_able = this.privileges.includes(DPubHol) ? true : false;
				
				if (!this.isPaid && is_able) {
					this.$emit('delete');
				}
			} else if(this.type === Event_Events) {
				if (this.isCreatByOther) {
					if (!this.privileges.includes(EVOwn)) {
						this.$emit('delete');
					}
				} else {
					this.$emit('delete');
				}
			} else {
				this.$emit('delete');
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.menu-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 16px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  background: #FAFAFA;
}
.menu-able {
	color: #192A3E;
	&:hover {
		background: #E8EAEC;
		cursor: pointer;
	}
}
.menu-delete {
	display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
 	padding: 8px 16px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  background: #FAFAFA;
}
.menu-delete-able {
	color: #192A3E;
  &:hover {
    color: #F45252;
		background: #E8EAEC;
    cursor: pointer;
  }
}
.menu-delete-disable {
  color: #82899B;
}

</style>